<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDocflow') }}</h1>
      <div class="form-container">
        <DocflowIncomingForm @save="save"
                      :edit-mode="true"
                      :document-data="documentData">
        </DocflowIncomingForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import DocflowIncomingForm from '@/components/DocflowIncomingForm'

  export default {
    components: {
      DashboardLayout,
      DocflowIncomingForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Docflow/update', {
          ...documentForm,
          category: 'incoming'
        }).then(document => {
          this.$router.push({
            name: 'docflowIncomingDetail',
            params: {documentId: document.id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelations', {category: 'incoming', documentId: this.$route.params.documentId})
    },
    computed: {
      ...mapState('Docflow', ['document']),
      documentData() {
        return this.document ? {
          ...this.document,
          registered_date: this.document.registered_date ? new Date(this.document.registered_date) : null,
          term_date: this.document.term_date ? new Date(this.document.term_date) : null,
          original_document_date: this.document.original_document_date ? new Date(this.document.original_document_date) : null
        } : {}
      },
      breadcrumbs() {
        return [
          { name: 'docflow', path: 'docflow' },
          {
            name: 'docflowDetail',
            path: {
              name: 'docflowIncomingDetail',
              params: {documentId: this.$route.params.documentId}
            }
          },
          { name: 'editDocflow' }
        ]
      }
    }
  }
</script>